import React from 'react';
import './index.css';
import App from './app';
import * as serviceWorker from './serviceWorker';
import 'semantic-ui-css/semantic.min.css';
import 'msteams-ui-styles-core/css/msteams-16.css';
import configureStore from './store';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';


const store = configureStore();


if (process.env.NODE_ENV !== "development"){
  console.log = () => {
    //disable logs for prod environment
  };
}
const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript

root.render(
  <Provider store={store}>
      <App />
  </Provider>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
